<template>
  <div>
    <transactions-table
      showSelect
      :tableName="tableName"
      :columns="columns"
      :actionsList="actionsList"
      @showReceiptModal="showReceiptModal"
      @showDetailTransactionModal="showTransactionModal"
      @showTransactionModal="showTransactionModal"
      @showMileageModal="showCreateMileageModal"
      @showDietModal="showDietModal"
      @showExpenseModal="showCreateExpenseModal"
    ></transactions-table>
    <transaction-edit-modal
      v-if="showTransactionsEditModalFlag"
      :open.sync="showTransactionsEditModalFlag"
      :transactionId.sync="transactionToEditId"
      @showReceiptModal="showReceiptModal"
      @closeModal="handleCloseTransactionReceiptModal"
      @showTransactionModal="showTransactionModal"
    ></transaction-edit-modal>
    <transaction-receipts-viewer-modal
      :open.sync="showTransactionReceiptModalFlag"
      :preloadReceiptId="preloadReceiptId"
      :transactionId.sync="transactionToShowReceiptId"
      v-if="showTransactionReceiptModalFlag"
    ></transaction-receipts-viewer-modal>
    <confirm-modal
      @dismiss="showConfirmDeleteTransactionModalFlag = false"
      @accept="deleteTransaction"
      :title="'ACTION_REMOVE'"
      :acceptText="'ACTION_REMOVE'"
      v-if="showConfirmDeleteTransactionModalFlag"
    ></confirm-modal>
    <create-expense-modal
      v-if="showEditExpenseModalFlag"
      :transactionId.sync="transactionToEditId"
      :open.sync="showEditExpenseModalFlag"
      @showReceiptModal="showReceiptModal"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @closeModal="handleCloseTransactionReceiptModal"
      @showTransactionModal="showTransactionModal"
    ></create-expense-modal>
    <create-mileage-modal
      v-if="showEditMileageModalFlag"
      :open.sync="showEditMileageModalFlag"
      :transactionId.sync="transactionToEditId"
      @showReceiptModal="showReceiptModal"
      @closeModal="handleCloseTransactionReceiptModal"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @showTransactionModal="showTransactionModal"
    ></create-mileage-modal>
    <create-diet-modal
      v-if="showEditDietModalFlag"
      :open.sync="showEditDietModalFlag"
      :transactionId.sync="transactionToEditId"
      @showReceiptModal="showReceiptModal"
      @closeModal="handleCloseTransactionReceiptModal"
      @confirmDelete="showConfirmDeleteTransactionModal"
      @showTransactionModal="showTransactionModal"
    >
    </create-diet-modal>
  </div>
</template>

<script>
import { BULK_FUNNEL_ACTIONS } from '@/constants/reviewStatus'
import _transactionsIndexViewShared from '../../../transactions/_mixins/_transactionsIndexViewShared'
import TransactionsTable from '@/modules/transactions/_components/_shared/TransactionsTable'
import TransactionEditModal from '@/modules/transactions/_components/_shared/TransactionsEditModal'
import TransactionReceiptsViewerModal from '@/modules/transactions/_components/_shared/TransactionReceiptsViewerModal'
import { segmentTrack } from '@/analytics/segment'
const CreateExpenseModal = () => import('@/modules/transactions/_components/expenses/CreateExpenseModal')
const CreateMileageModal = () => import('@/modules/transactions/_components/expenses/CreateMileageModal')
const CreateDietModal = () => import('@/modules/transactions/_components/expenses/CreateDietModal')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'UserReimbursements',
  components: {
    TransactionsTable,
    TransactionEditModal,
    CreateExpenseModal,
    CreateMileageModal,
    CreateDietModal,
    TransactionReceiptsViewerModal,
    ConfirmModal
  },
  mixins: [
    _transactionsIndexViewShared
  ],
  data () {
    return {
      showTransactionsEditModalFlag: false,
      showTransactionReceiptModalFlag: false,
      transactionToEditId: 0,
      preloadReceiptId: 0,
      transactionToShowReceiptId: 0,
      showConfirmDeleteTransactionModalFlag: false,
      showEditMileageModalFlag: false,
      showEditExpenseModalFlag: false,
      showEditDietModalFlag: false,
      showExpenseReceiptPreviewModalFlag: false,
      tableName: 'reimbursements'
    }
  },
  computed: {
    BULK_FUNNEL_ACTIONS () {
      return BULK_FUNNEL_ACTIONS
    },
    userId () {
      return this.$route.params.id || ''
    },
    columns () {
      return this.$store.getters['TransactionsStore/tableColumns'].filter(item => item.table ? item.table.includes(this.tableName) : item)
    }
  },
  methods: {
    async fetchTransactions () {
      const defaultFilters = {
        'order[id]': 'DESC',
        'type.code': 'EXPENSE',
        'card.user.id': this.userId
      }
      await this.$store.dispatch('TransactionsStore/setTransactionsFilters', { filters: defaultFilters, expenses: this.expenses })
    },

    showConfirmDeleteTransactionModal (event) {
      this.showConfirmDeleteTransactionModalFlag = true
      this.transactionToEditId = event
    },
    showCreateMileageModal (event) {
      this.transactionToEditId = event
      this.showEditMileageModalFlag = true
      this.showEditExpenseModalFlag = false
      this.showEditDietModalFlag = false
    },
    showCreateExpenseModal (event) {
      this.transactionToEditId = event
      this.showEditMileageModalFlag = false
      this.showEditExpenseModalFlag = true
      this.showEditDietModalFlag = false
    },
    showDietModal (event) {
      this.transactionToEditId = event
      this.showEditMileageModalFlag = false
      this.showEditExpenseModalFlag = false
      this.showEditDietModalFlag = true
    },
    handleCloseTransactionReceiptModal () {
      if (this.showTransactionReceiptModalFlag) {
        this.showTransactionReceiptModalFlag = false
        this.$store.dispatch('TransactionsStore/setReceiptModalIsOpen', false)
      }
    },

    async deleteTransaction () {
      await this.$store.dispatch('TransactionsStore/deleteTransaction', this.transactionToEditId)
      this.showTransactionsEditModalFlag = false
      this.showEditDietModalFlag = false
      this.showEditExpenseModalFlag = false
      this.showEditMileageModalFlag = false
      this.showConfirmDeleteTransactionModalFlag = false
    }

  },
  async created () {
    this.$store.dispatch('TransactionsStore/clearStore')
    await this.fetchTransactions()
    segmentTrack('User transactions opened', {
      member_transactions_charged_count: this.$store.getters['TransactionsStore/totalItems']
    })
  }
}
</script>

<style src="@/assets/styles/multiselect/multiselect-section-selector.css" scoped >
</style>
